import { Button, Grid, Modal, Typography, useMediaQuery, useTheme } from "@mui/material";
import React, { useState } from "react";
import CButton from "../../../basecomp/components/CButton3";
import CDateTimePicker from "../../../basecomp/components/CDateTimePicker";
import CTable from "../../../basecomp/components/CTable";
import BinLocationVM from "../viewmodel/BinLocationVM";
import CChooseFile from "../../../basecomp/components/CChooseFile";
import CBackDrop from "../../../basecomp/components/CBackDrop";
import WarehouseIcon from "@mui/icons-material/Warehouse";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import ViewListIcon from "@mui/icons-material/ViewList";
import { useTranslation } from "react-i18next";
import { Box } from "@mui/system";
import { CheckCircle } from "@mui/icons-material";
import CText from "../../../basecomp/components/CText";

const BinLocationDetails = () => {
  const {
    downloadExportAllFile,
    getBinLocationDetails,
    binLocationData,
    handleStartDateChange,
    handleEndDateChange,
    loading,
    adminBinUploadAccess,
    handleFileChoose,
    handleBinLocFileUpload,
    handleSampleFileDownload,
    alertModelOpen,
    responseMessage,
    handleFileDownload
  } = BinLocationVM();
  const { t } = useTranslation();
  const theme = useTheme();
  const isXs = useMediaQuery(theme.breakpoints.down("sm"));
  const [infoRowData, setInfoRowData] = useState([
    { value: `material_no`, status: false, type: "T" },
    { value: `terminal_id`, status: false, type: "T" },
    { value: `storage_loc`, status: false, type: "T" },
    { value: `storage_bin`, status: false, type: "T" },
    { value: `created_by`, status: false, type: "T" },
    { value: `created_at`, status: false, type: "T" },
    { value: `updated_by`, status: false, type: "T" },
    { value: `updated_at`, status: false, type: "T" },
  ]);

  const infoHeadData = [
    t("material_number"),
    t("plant"),
    t("str_loc"),
    t("str_bin"),
    t("created_by"),
    t("created_at"),
    t("updated_by"),
    t("updated_at"),
  ];

  return (
    <div
      style={{
        marginTop: "6em",
        padding: "1rem 1rem",
      }}
    >

      <Modal
        open={alertModelOpen}
        onClose={(e, reason) => {
          if (reason === "backdropClick") return;
        }}
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 340,
            bgcolor: "#fff",
            borderRadius: "16px",
            boxShadow: "0 10px 30px rgba(0,0,0,0.2)",
            p: 4,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            textAlign: "center",
          }}
        >
          {/* Icon */}
          <CheckCircle
            sx={{ fontSize: 60, color: "#4caf50", mb: 1.5 }}
          />

          {/* Title */}
          <Typography
            sx={{
              fontSize: "20px",
              fontWeight: 600,
              mb: 1,
            }}
          >
            Success
          </Typography>

          {/* Message */}
          <Typography
            sx={{
              fontSize: "14px",
              color: "#666",
              mb: 3,
            }}
          >
            {responseMessage}
          </Typography>

          {/* Button */}
          <Button
            onClick={() => window.location.reload()}
            sx={{
              width: "100%",
              backgroundColor: "#0D2C6C",
              color: "#fff",
              borderRadius: "10px",
              textTransform: "none",
              fontWeight: 500,
              py: 1,
              "&:hover": {
                backgroundColor: "#0A2458", // slightly darker for hover
              },
            }}
          >
            OK
          </Button>
        </Box>
      </Modal>
      <div
        style={{
          display: "flex",
          justifyContent: "space-evenly",
          alignItems: "center",
          marginBottom: "4rem",
          gap: "3rem",
          flexDirection: isXs ? "column" : "row",
        }}
      >
        <CBackDrop cOpen={loading} />

        {/* Admin Section */}
        {adminBinUploadAccess && (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              gap: "2rem",
              width: isXs ? "100%" : "50%",
              flexDirection: isXs ? "column" : "row",
            }}
          >
            <div style={{ marginTop: "1.5rem", width: "100%" }}>
              <CChooseFile
                cFileType="XCL"
                cTooltipText="Upload excel"
                cHelperText={t("file_type")}
                cHandleFileChange={handleFileChoose}
                cFullWidth={true}
                cIsRequired={true}
              />
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                gap: "1rem",
              }}
            >
              <CButton
                cSrc={<CloudUploadIcon />}
                cIsMain={true}
                cTooltipText={t("upload_bin")}
                cOnClick={handleBinLocFileUpload}
              />
              <CButton
                cSrc={<WarehouseIcon />}
                cIsMain={true}
                cTooltipText={t("download_sample_bin")}
                cOnClick={handleSampleFileDownload}
              />
            </div>
          </div>
        )}

        {/* Date Filters and Action Buttons Section */}
        <div
          style={{
            padding: 2,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap: "1.1rem",
            width: isXs ? "100%" : "50%",
            flexDirection: isXs ? "column" : "row",
          }}
        >
          <div style={{ marginTop: "1rem", width: "100%" }}>
            <CDateTimePicker
              cHelperText={t("start_date")}
              cOnChange={handleStartDateChange}
              cFullWidth={true}
              hideTime={true}
            />
          </div>
          <div style={{ marginTop: "1rem", width: "100%" }}>
            <CDateTimePicker
              cHelperText={t("end_date")}
              cOnChange={handleEndDateChange}
              cFullWidth={true}
              hideTime={true}
            />
          </div>
          <Grid
            item
            xs={12}
            md={6}
            container
            spacing={1}
            gap={2}
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              paddingLeft: ".5rem",
            }}
          >
            <Grid>
              <CButton
                cSrc={<ViewListIcon />}
                cIsMain={true}
                cTooltipText={t("view_bin_file")}
                cOnClick={getBinLocationDetails}
              />
            </Grid>
            <Grid>
              <CButton
                cSrc={<FileDownloadIcon />}
                cIsMain={true}
                cTooltipText={t("download_bin_file")}
                cOnClick={downloadExportAllFile}
                cDisabled={binLocationData.length === 0}
              />
            </Grid>
          </Grid>
        </div>
      </div>
      {/* Table Section */}
      {binLocationData && binLocationData.length > 0 && (
        <Grid
          container
          sx={{
            width: "100%",
            "& .MuiGrid-root": {
              width: "100%",
            },
          }}
        >
          <Grid item xs={12}>
            <CTable
              id="label_info_table"
              cHeaderData={infoHeadData}
              cRowData={infoRowData}
              cActualData={binLocationData}
              cIsPagination={true}
              cSmallSize={true}
              cColor="#2196f3"
            />
          </Grid>
        </Grid>
      )}

      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          marginBottom: "4rem",
          gap: "3rem",
          flexDirection: isXs ? "column" : "row",
        }}
      >
        

        
          <div style={{ marginTop: "1.5rem", display:"flex", justifyContent:"center",alignItems:"center",gap:"1.5rem" }}>
            <CText cText={"Bin Location file download"}/>
          
          
            <CButton
              cSrc={<FileDownloadIcon />}
              cIsMain={true}
              cTooltipText={t("Download_bin")}
              cOnClick={()=>handleFileDownload("Bin")}
            />
          </div>

          <div style={{ marginTop: "1.5rem",display:"flex", justifyContent:"center",alignItems:"center",gap:"1.5rem"  }}>
            <CText cText={"Bulk Location file download"}/>
          
          
            <CButton
              cSrc={<FileDownloadIcon />}
              cIsMain={true}
              cTooltipText={t("Download_bulk")}
              cOnClick={()=>handleFileDownload("Bulk")}
            />
            </div>
           
      </div>



    </div>
  );
};

export default BinLocationDetails;
